import { useEffect } from 'react'
import mixpanel from 'mixpanel-browser'
import { useRouter } from 'next/router'

let mixpanelInstance: mixpanel.Mixpanel | undefined
let shop

const getMixpanel = (): mixpanel.Mixpanel | undefined => {
  if (!mixpanelInstance) {
    mixpanel.init(process.env.NEXT_PUBLIC_MIXPANEL_TOKEN)
    mixpanel.set_config({ persistence: 'localStorage' })
    mixpanelInstance = mixpanel
  }

  return mixpanelInstance
}

interface TrackProps {
  [key: string]: string | number | boolean | Date | undefined
}

export const useMixpanel = () => {
  const router = useRouter()
  const url = new URL(window.location.href)
  shop = url.searchParams.get('shop')

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const mixpanel = getMixpanel()

      if (mixpanel && shop) {
        mixpanel.identify(shop)

        const pageTitle = document.title
        const pageUrl = window.location.pathname
        mixpanel.track('Page Viewed', { 'Page Title': pageTitle, 'Page URL': pageUrl })
      }
    }
  }, [router.pathname])

  const track = (event: string, props: TrackProps) => {
    const mixpanel = getMixpanel()

    if (mixpanel && shop) {
      const pageTitle = document.title
      const pageUrl = window.location.pathname

      mixpanel.identify(shop)
      mixpanel.track(event, { ...props, 'Page Title': pageTitle, 'Page URL': pageUrl })
    }
  }

  const setShopProps = (props: TrackProps) => {
    const mixpanel = getMixpanel()

    if (mixpanel && shop) {
      mixpanel.identify(shop)
      mixpanel.people.set({
        ...props,
      })
    }
  }

  return { track, setShopProps }
}
